import React, { PureComponent } from 'react';
import { Button } from '@ui-propulsion/react-components';
import TextField from './text-field';
import NumberField from './number-field';
import Modal from './modal';
import classNames from 'classnames';
import ActionArea from './action-area';
import BackButton from './back-button';
import { validNameKey, handleOnPasteForNameField } from '../lib/valid-key';
import Spinner from './spinner';
import { BounceLoader } from 'react-spinners';
import styled from '@emotion/styled';

class AchInformation extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      accountNumber: props.practice.achAccountNumber,
      confirmAccountNumber: props.practice.achConfirmAccountNumber,
      routingNumberHelperText: props.practice.achBankName,
      showModal: false,
      loadingBankInfo: false,
    };
  }

  handleClose = () => {
    this.setState({ showModal: false });
  }

  handleShow = () => {
    this.setState({ showModal: true });
  }

  handleNameChange = (e) => {
    const { value } = e.target;
    const { enterFieldData } = this.props.actions;
    enterFieldData('achAccountName', value, {
      isRequired: false,
      fieldDisplayName: 'Account Holder Name'
    });
  }

  handleNameChangeBlur = (e) => {
    const { value } = e.target;
    const { enterFieldData } = this.props.actions;
    enterFieldData('achAccountName', value, {
      isRequired: true,
      fieldDisplayName: 'Account Holder Name'
    });
  }

  enterRoutingNumberHelper = (value) => {
    const { enterRoutingNumber } = this.props.actions;
    this.setState({loadingBankInfo: true});
    enterRoutingNumber(value, false)
      .then(() => {
        const { practice: { achBankName }, errors } = this.props;
        if (achBankName) {
          this.setState({ routingNumberHelperText: achBankName, loadingBankInfo: false });
        } else if (errors.achBankName) {
          this.setState({ routingNumberHelperText: errors.achBankName, loadingBankInfo: false });
        }
      })
      .catch(error => {
        this.setState({loadingBankInfo: false})
      });
  }

  handleRoutingNumberChange = (e) => {
    const { value } = e.target;
    this.setState({ routingNumberHelperText: null });
    if (value && value.length === 9) {
      this.enterRoutingNumberHelper(value);
    } else {
      const { saveRoutingNumber } = this.props.actions;
      saveRoutingNumber(value);
    }
  };

  handleRoutingNumberBlur = (e) => {
    const { value } = e.target;
    const { saveRoutingNumberError } = this.props.actions;
    saveRoutingNumberError(value);
  };

  onAccountNumberChange = (e) => {
    const { value: accountNumber } = e.target;
    const {
      errors,
      actions: { enterFieldData, checkMatchingAccountNumber }
    } = this.props;

    const {
      confirmAccountNumber
    } = this.state;

    enterFieldData('achAccountNumber', accountNumber, {
      isRequired: true,
      fieldDisplayName: 'Account Number'
    });

    if (errors.achConfirmAccountNumber) {
      checkMatchingAccountNumber(accountNumber, confirmAccountNumber);
    }
  }

  handleAccountNumberChange = (e) => {
    const { value } = e.target;
    const { confirmAccountNumber } = this.state;
    const { errors } = this.props;
    const {
      enterFieldData,
      checkMatchingAccountNumber
    } = this.props.actions;

    enterFieldData('achAccountNumber', value, {
      isRequired: true,
      fieldDisplayName: 'Account Number'
    });

    if (errors.achConfirmAccountNumber || confirmAccountNumber) {
      checkMatchingAccountNumber(value, confirmAccountNumber);
    }
  };

  handleConfirmAccountNumberChange = (e) => {
    const { value: confirmAccountNumber } = e.target;
    const { checkMatchingAccountNumber, enterFieldData } = this.props.actions;
    const { errors } = this.props;
    this.setState({ confirmAccountNumber }, () => {
      if (errors.achConfirmAccountNumber) {
        const { practice: { achAccountNumber } } = this.props;
        checkMatchingAccountNumber(achAccountNumber, confirmAccountNumber);
      } else {
        enterFieldData('achConfirmAccountNumber', confirmAccountNumber, {
          isRequired: false
        });
      }
    });
  };

  handleConfirmAccountNumberChangeBlur = (e) => {
    const { value: confirmAccountNumber } = e.target;
    const { checkMatchingAccountNumber } = this.props.actions;
    this.setState({ confirmAccountNumber }, () => {
      const { practice: { achAccountNumber } } = this.props;
      checkMatchingAccountNumber(achAccountNumber, confirmAccountNumber);
    });
  };

  preventPasteEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  handleSubmit = () => {
    const { history, actions, practice } = this.props;
    const { submitAchInfo } = actions;
    submitAchInfo(practice)
      .then((result) => {
        if (result && result.capAlreadyReview) { return; }
        
        actions.setPreviousRoute('/patientsolutions/enroll/ach-information');
        history.push('/patientsolutions/enroll/review');
      })
      .catch((response) => {
        const { status = 500, data } = response;

        if (status && status !== 400) {
          window.location.href = '/patientsolutions/enroll/error';
        }

        if (data && data.redirectTo) {
          window.location.href = data.redirectTo;
        }
      });
  }

  imageDiv = (cName) => {
    return (
      <div className={cName}>
        <img className='bank-check'></img>
      </div>
    );
  }

  render() {
    const { isInReview, onboarding } = this.props;
    const { processingSubmit, hasCompletedReview } = onboarding;
    const previousRoute = isInReview
      ? onboarding.previousRoute
      : '/patientsolutions/enroll/ownership/significant-owner';

    const additionalAchNameProps = {};
    if (isInReview) {
      additionalAchNameProps.disabled = 'disabled';
      additionalAchNameProps.inputClassName = 'txt-field-input disabled';
    } else {
      additionalAchNameProps.onKeyDown = validNameKey;
      additionalAchNameProps.onBlur = this.handleNameChangeBlur;
      additionalAchNameProps.onPaste = handleOnPasteForNameField;
      additionalAchNameProps.autoFocus = true;
      additionalAchNameProps.onChange = this.handleNameChange;
    }

    const buttonActionProps = {
      ...this.props,
      className: 'button-submit-next',
      onSubmit: this.handleSubmit
    };

    if (hasCompletedReview) {
      buttonActionProps.disabled = true;
    }
    
    const cssStyles = styled.div`
      marginTop: '.5rem',
    `;

    return <section className='header-section ach-section'>
      <BackButton {...this.props} previousRoute={previousRoute} />
      <h1 className='section-title'>Set up your direct deposit</h1>
      <p>Direct deposit to your business or practice <b>checking account</b> is required in order for us to transmit funds to your practice for your patient’s procedure. We will deposit funds within three business days of your patient’s completed documents being accepted. </p>
      <div className='ach-main'>
        <div className='mobile-only'>
              <a className='routing-info' onClick={this.handleShow}>Where can I find my Routing and Account Numbers?</a>
            </div>
          <form>
            <label className='bank-info-label'><b>BANK INFORMATION</b></label>
            <TextField
              data-test-id="ach-holder-name-field"
              aria-required
              errorMsg={this.props.errors.achAccountName}
              defaultValue={this.props.practice.achAccountName}
              className='input-helper'
              inputClassName='txt-field-input'
              placeholder='Full Name or Company Name'
              htmlFor='account_holder_name'
              labelText='Account Holder Name'
              labelClassName='section-label'
              {...additionalAchNameProps}
            />

            <NumberField
              data-test-id="routing-number-field"
              htmlFor='routing_number'
              maxLength={9}
              inputClassName='txt-field-input-small'
              placeholder='9 digit number'
              labelText='Routing Number'
              labelClassName='section-label'
              className='input-helper'
              errorMsg={this.props.errors.achRoutingNumber}
              onBlur={this.handleRoutingNumberBlur}
              onChange={this.handleRoutingNumberChange}
              value={this.props.practice.achRoutingNumber}
              helperTextClassName={this.props.errors.achRoutingNumber ? 'section-helper-txt' : 'helper-display-block'}
              helperText={this.state.routingNumberHelperText}
            />
            <BounceLoader
              cssOverride={cssStyles}
              sizeUnit='px'
              size={20}
              color={'#113b5e'}
              loading={this.state.loadingBankInfo}
            />

            <NumberField
              data-test-id="account-number-field"
              htmlFor='account_number'
              inputClassName={classNames('txt-field-input-small', 'ach-mobile-txt-field-input-small')}
              labelText='Account Number'
              labelClassName='section-label'
              className='input-helper'
              onInput={this.onAccountNumberChange}
              errorMsg={this.props.errors.achAccountNumber}
              onChange={this.onAccountNumberChange}
              onBlur={this.handleAccountNumberChange}
              defaultValue={this.props.practice.achAccountNumber}
            />

            <NumberField
              data-test-id="confirm-account-number-field"
              htmlFor='confirm_account_number'
              inputClassName={classNames('txt-field-input-small', 'ach-mobile-txt-field-input-small')}
              labelText='Confirm Account Number'
              labelClassName='section-label'
              className='input-helper'
              errorMsg={this.props.errors.achConfirmAccountNumber}
              onBlur={this.handleConfirmAccountNumberChangeBlur}
              onInput={this.handleConfirmAccountNumberChange}
              onPaste={this.preventPasteEvent}
              defaultValue={this.props.practice.achConfirmAccountNumber}
            />

            <ActionArea { ...buttonActionProps }>
                <span className='button-submit-text'>Next</span> <span className='chevron-white-right' />
            </ActionArea>

            { processingSubmit && <Spinner processingSubmit={processingSubmit}/> }

          </form>

          { this.imageDiv('bank-check-wrapper') }

          <Modal
            isOpen={this.state.showModal}
            onHide={this.handleClose}
            className='ach-modal'
            centered
            showClose={false}
          >
          <div>
            <p className='ach-modal-body'>Your routing and account number can be found on the bottom left of one of your checks.</p>
            { this.imageDiv('bank-check-wrapper-mobile') }
          </div>
          <div className='action-area'>
            <Button
              className='button-submit'
              onClick={this.handleClose}
              aria-label='modal close button'>
              <span className='button-submit-text'>Close</span>
            </Button>
          </div>
        </Modal>
      </div>
    </section>;
  }
}

export default AchInformation;

